// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__OHTrG","left":"InfoRow_left__3k38d"};